import { PDFDocument } from 'pdf-lib'

import { convertDateString, createTable, savePdf } from '../../../../helpers/pdf'
import { IEventInterface } from '../../../../models/events/event.interface'

export interface GroupedRows {
  day: string
  date: Date
  facility: string
  rows: string[][]
}

export const createOrderOfGoByDayAndRing = async (
  event: IEventInterface,
  groupedData: GroupedRows[]
) => {
  // Create a new PDF document
  const pdfDoc = await PDFDocument.create()
  const headers = ['Time', 'Class', 'Rider • Horse • Trainer']
  const colWidths = [20, 50, 30] // in %
  const titleText = 'Order of Go by Day and Ring'
  const printedText = `^^Printed ${convertDateString(new Date(), 'tdm')}^^`
  const urlText = 'www.thepegasus.app'

  // Create a table for each group
  for (const [index, group] of groupedData.entries()) {
    // Format the date string
    const formattedDate = convertDateString(group.date, 'dm') // Format like "08 Jul"

    // Generate the title in the specified format
    const groupTitle = `**${group.day}, ${formattedDate}** • ${group.facility} • ~~${group.rows.length} rides~~`

    // Create table for this group
    await createTable({
      pdfDoc,
      headers,
      rows: group.rows,
      colWidths,
      textAboveTheFirstTable: groupTitle,
      printedText: index === 0 ? printedText : undefined, // only show printedText on first page
      titleText: index === 0 ? titleText : undefined, // only show title on first page
      urlText: index === 0 ? urlText : undefined, // only show url on the first page
      currentPageNumber: index + 1,
      event,
    })
  }

  await savePdf(pdfDoc, `Event Reports - Order of Go by Day and Ring - ${event?.eventName}.pdf`)
}
